import api from '../../apiConfig/apiConfig'
import { Get, Post, Put, Delete, Patch } from '../base/baseAjax'

export default {
  addCustomer(param) {
    return Post({
      url: api.customer.addCustomer,
      bodyParam: param,
    })
  },
  focus(param) {
    return Get({
      url: api.customer.focus,
      PathParam: param,
    })
  },
  setCustomerTag(param) {
    return Post({
      url: api.customer.setCustomerTag,
      bodyParam: param,
    })
  },
  setAsPublic(param) {
    return Post({
      url: api.customer.setAsPublic,
      bodyParam: param,
    })
  },
  transferCustomer(param) {
    return Get({
      url: api.customer.transferCustomer,
      PathParam: param,
    })
  },
  transferCustomerGroup(param) {
    return Get({
      url: api.customer.transferCustomerGroup,
      PathParam: param,
    })
  },
  distributionCustomer(param) {
    return Get({
      url: api.customer.distributionCustomer,
      PathParam: param,
    })
  },
  catchCustomer(param) {
    return Get({
      url: api.customer.catchCustomer,
      PathParam: param,
    })
  },
  addDynamic(param) {
    return Post({
      url: api.customer.addDynamic,
      bodyParam: param,
    })
  },
  dynamicList(param) {
    return Get({
      url: api.customer.dynamicList,
      PathParam: param,
    })
  },
  addContact(param) {
    return Post({
      url: api.customer.addContact,
      bodyParam: param,
    })
  },
  contactList(param) {
    return Get({
      url: api.customer.contactList,
      PathParam: param,
    })
  },
  modifyContact(param) {
    return Put({
      url: api.customer.modifyContact,
      bodyParam: param,
    })
  },
  countryList() {
    return Get({
      url: api.customer.countryList,
    })
  },
  industryList() {
    return Get({
      url: api.customer.industryList,
    })
  },
  customerDetails(param) {
    return Get({
      url: api.customer.customerDetails,
      PathParam: param,
    })
  },
  updateData(param) {
    return Post({
      url: api.customer.updateData,
      bodyParam: param,
    })
  },
  boardChartList(param) {
    return Get({
      url: api.customer.boardChartList,
      PathParam: param,
    })
  },
}
